import { isNil } from 'lodash'

import { applicationStore } from '..'
import { SetupApplicationStoreOptions } from '../interface'

export const setupApplicationStore = async ({
  cipherEnabled,
  getCipherApi
}: SetupApplicationStoreOptions) => {
  if (getCipherApi) {
    const res = await getCipherApi()
    if (res && res.secret && res.iv) {
      applicationStore.setState({
        cipherConfig: {
          secret: res.secret,
          iv: res.iv
        }
      })
    }
  }
  if (!isNil(cipherEnabled)) {
    applicationStore.setState({
      cipherEnabled
    })
  }
}
